import React from 'react';
import { VStack } from 'native-base';

export default function Column(props) {
  return <VStack space={3} justifyContent="center" {...props}>
    {props.children}
  </VStack>;
};
